export enum ExportChannels {
  /** Renders standalone HTML to PDF in an offscreen window and offers a save dialog. */
  EXPORT_PDF = 'export-pdf',
  /** Writes an already-generated file (e.g. a DOCX buffer) via a save dialog. */
  SAVE_FILE = 'export-save-file',
  /** Opens the folder holding a file one of the two above just saved, with the file selected. */
  SHOW_IN_FOLDER = 'export-show-in-folder',
}

export interface ExportPdfPayload {
  html: string;
  /** Suggested file name, without extension. */
  fileName: string;
  landscape?: boolean;
}

export interface SaveFilePayload {
  data: Uint8Array;
  fileName: string;
  extension: string;
  description: string;
}

export interface ExportResult {
  saved: boolean;
  filePath?: string;
  error?: string;
}
